import { render, staticRenderFns } from "./alert-widget.vue?vue&type=template&id=4c08cff5&scoped=true&"
import script from "./alert-widget.vue?vue&type=script&lang=js&"
export * from "./alert-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c08cff5",
  null
  
)

export default component.exports